import { __awaiter, __generator } from '../node_modules/tslib/tslib.es6.js';

var sendText = function (axios, request) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                request.phoneNumber = request.phoneNumber.indexOf('+') === 0 ? request.phoneNumber : "+1".concat(request.phoneNumber);
                return [4 /*yield*/, axios.post('/waitingList/textLinkToDownloadApp', request)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.data];
        }
    });
}); };
var searchProductsRest = function (axios, body, page, facets, cancelToken) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.post('/product/search', { body: body, page: page, facets: facets }, {
                    cancelToken: cancelToken,
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res === null || res === void 0 ? void 0 : res.data];
        }
    });
}); };
var getEntityForLandingPage = function (_a) {
    var axiosEdgeCached = _a.axiosEdgeCached, entityId = _a.entityId, entityType = _a.entityType;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, axiosEdgeCached.get("/cms/landing/".concat(entityType, "/").concat(entityId, "/entity"))];
        });
    });
};
var getRecentlySearchedTerms = function (axios, headers) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, axios.get('/recentlyViewed/getSearches', { headers: headers })];
    });
}); };

export { getEntityForLandingPage, getRecentlySearchedTerms, searchProductsRest, sendText };
//# sourceMappingURL=utils.js.map
